import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { BreadcrumbContainer, Crumb, LastCrumb } from './styles'

class Breadcrumb extends Component {

  render() {
    const { title, parent, parentUrl, grandparent, grandparentUrl, fill } = this.props
    
    return (
      <BreadcrumbContainer fill={fill}>

        <Crumb>
          <Link to="/">Dashboard</Link>
        </Crumb>

        {grandparent && grandparentUrl ? (
          <Crumb>
            <Link to={grandparentUrl}>{grandparent}</Link>
          </Crumb> 
        ) : null }

        {grandparent && !grandparentUrl ? (
          <Crumb>{grandparent}</Crumb>
        ) : null }

        {parent && parentUrl ? (
          <Crumb>
            <Link to={parentUrl}>{parent}</Link>
          </Crumb>  
        ) : null }

        {parent && !parentUrl ? (
          <Crumb>{parent}</Crumb>
        ) : null }

        <LastCrumb>{title}</LastCrumb>

      </BreadcrumbContainer>
    )
  }
}

export default withRouter(Breadcrumb)


// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.js